import { atom } from 'recoil'

import { deleteSystemApprovalProps } from './types'

const deleteSystemApproval: deleteSystemApprovalProps = {
  open: false,
  backofficeUserId: undefined,
  fullname: undefined,
  onSuccess: undefined,
}

const deleteSystemApprovalAtom = atom({
  key: 'deleteSystemApprovalAtom',
  default: deleteSystemApproval,
})

export default deleteSystemApprovalAtom
